export default {
    translation: {
        title: "America",
        applications: "Aplicativos",
        full_text: "Texto Completo",
        vehicle: {
            status: "Dirigindo {{direction}} a {{speed}} mph.",
            statusWithLocality:
                "Dirigindo {{direction}} por {{locality}} a {{speed}} mph."
        },
        talkie: {
            drivers_nearby_singular: "1 motorista por perto",
            drivers_nearby_plural: "{{count}} motoristas por perto"
        },
        settings: {
            save_progress_description:
                "Salve seu progresso em um disquete para backup ou para transferir entre computadores.",
            save_progress_action: "Salvar Progresso",
            load_progress_action: "Carregar Progresso...",
            display_units: "Unidades de Exibição",
            imperial: "Imperial",
            metric: "Métrico",
            start_over_description:
                "Termine sua jornada antecipadamente. O progresso atual será apagado. Isso não pode ser desfeito.",
            start_over_action: "Começar de Novo"
        },
        feedback: {
            message: "Mensagem",
            contact_info: "Informações de contato (opcional)",
            send: "Enviar",
            sending: "Enviando..."
        },
        radio: {
            no_reception: "sem sinal de rádio nesta área",
            low_signal: "sinal fraco",
            turn_off: "Desligar",
            turn_on: "Ligar",
            next_station: "Próxima Estação",
            unmute: "Ativar Som",
            mute: "Silenciar"
        },
        photos: {
            source: "Do Mapillary",
            empty: "Procurando ao redor para tirar uma foto..."
        },
        news: {
            loading: "Verificando as manchetes locais...",
            nothing_found: "Nada encontrado."
        },
        metrics: {
            duration_title: "Tempo de Direção",
            duration_value: "{{days}}d {{hours}}h {{minutes}}m",
            distance_title: "Distância Percorrida",
            emissions_title: "CO2 do Escape",
            emissions_value_g: "{{g}} g",
            emissions_value_kg: "{{kg}} kg",
            states_visited_title: "Estados Visitados",
            cairns_discovered_title: "Cairns Descobertos",
            exploration_title: "Exploração"
        },
        compass: {
            north_east: "Nordeste",
            east: "Leste",
            south_east: "Sudeste",
            south: "Sul",
            south_west: "Sudoeste",
            west: "Oeste",
            north_west: "Noroeste",
            north: "Norte"
        },
        landing: {
            about_title: "Sobre",
            start_title: "Iniciar",
            features_title: "Recursos",
            about_headline: "America: simulador de viagem de carro no seu navegador",
            about_paragraph_1:
                "Safari, Chrome, Edge. Estes são portais para os cantos infinitos da web.\n"
                + "America é o seu portal para outro tipo de terreno extenso: as maravilhas\n"
                + "naturais dos Estados Unidos, onde há tanto a aprender, no seu ritmo.\n",
            about_paragraph_2:
                "De paisagens monumentais a momentos tranquilos à beira da estrada, você\n"
                + "conduz a viagem por meio de uma interface com janelas estilo desktop: mapa,\n"
                + "rádio ao vivo, artigos de enciclopédia, rolo de câmera, métricas, diário e\n"
                + "mais. Sem placar, sem pressa: serendipidade e atmosfera em primeiro lugar.\n"
                + "Abra em um navegador moderno; nada para instalar.",
            about_paragraph_3:
            "Sua viagem pode seguir a Pacific Coast Highway, traçar a Rota 66 pelas"
                + "planícies, cruzar as Montanhas Rochosas rumo aos parques nacionais ou vagar"
                + "pelas estradas secundárias da Nova Inglaterra. Cada parada revela a história"
                + "local: o que esta cidade, cânion ou mirante viu, o que toca no rádio e como"
                + "está o tempo agora. É um simulador de viagem para explorar os EUA no seu"
                + "ritmo, no navegador, em qualquer dispositivo.",

            trips_title: "Explore por viagem",
            trips_list: [
                { label: "Viagem virtual de carro", url: "/virtual-road-trip/" },
                { label: "Viagem de carro pelos EUA", url: "/us-road-trip/" },
                { label: "Viagem pelos parques nacionais", url: "/national-parks-road-trip/" },
                { label: "Viagem pela Rota 66", url: "/route-66-road-trip/" },
                { label: "Explore a América", url: "/explore-america/" },
                { label: "Viagem de carro através da América", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "Assistir comercial",
            start_cta: "Iniciar viagem",
            start_cta_lead: "Sem instalação. Roda no seu navegador.",
            features_lede:
                "Depois que sua jornada começar, você configura o painel a partir do\n"
                + "conjunto de ferramentas de viagem de carro da America. Cada janela é uma\n"
                + "maneira diferente de experimentar o país. De rádio local a um walkie-talkie\n"
                + "com outros motoristas, você vai descobrir algo novo em toda viagem.",
            features_list: [
                "Mapa com roteamento e exploração pelos EUA",
                "Rádio em streaming e artigos e fotos vinculados a locais",
                "Diário, métricas, rolo de câmera e enciclopédia",
                "Amigos, chat de voz e marcos compartilhados na estrada (cairns)",
                "Roda no navegador no celular ou desktop; sem download"
            ],
            media_alt: "America Complete Edition: caixa de software e CD",
            slideshow_alt: "Fotografia de paisagens de viagem de carro do simulador America, imagem",
            og_title: "America: Simulador de Viagem de Carro",
            og_description:
                "Explore as maravilhas naturais dos Estados Unidos em um simulador de viagem de carro descontraído com estilo de desktop. Mapas, rádio, diário e descobertas serendípitas, direto no seu navegador.",
            twitter_description:
                "Explore as maravilhas naturais dos Estados Unidos em um simulador de viagem de carro descontraído com estilo de desktop. Sem instalação necessária.",
            meta_description:
                "Dirija por estradas reais dos EUA e explore maravilhas naturais em um simulador de viagem gratuito. Mapas, rádio, fotos. Sem download.",
            jsonld_description:
                "America é um simulador de viagem de carro no seu navegador: explore as maravilhas naturais dos EUA no seu ritmo com mapas, rádio, fotos e uma interface estilo desktop. Sem download necessário; comece sua viagem online.",
            jsonld_genre: ["Simulador de viagem de carro", "Jogo de exploração", "Jogo de navegador"],
            page_title: "Simulador de viagem de carro nos EUA | America",
            html_lang: "pt",
            og_locale: "pt_BR",
            og_locale_alternate: ["en_US", "es_ES", "fr_FR", "de_DE", "ru_RU", "ja_JP", "ko_KR", "zh_CN"],
            og_image_alt: "Captura de tela do simulador de viagem de carro America",
            twitter_image_alt: "Captura de tela do simulador de viagem de carro America",
        },
    }
};
